import { bootstrapFactory } from './bootstrapFactory';

bootstrapFactory(window)();
